import React from 'react';
import Banner from '../../Layout/Banner/Banner';
import Mapa from './Mapa/Mapa';
import Form from './Form/Form';
import CityWatter from '../../Layout/cityWatter/cityWatter';
import { dataCityWatter } from '../../../json/layout/cityWatter';

const Contact = () => {
    return (
        <>
            <Banner />
           {/*  <Mapa /> */}
            <Form />
            <CityWatter data={dataCityWatter} />
        </>
    )
}

export default Contact